import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
const isFor = ["Madres de adolescentes que reciben respuestas de una sola palabra ('bien', 'no sé', 'nada').", 'Mujeres que sienten que han perdido el control y la autoridad en su propia casa.', 'Madres que lloran en silencio por la distancia emocional que hay con su hijo.', 'Personas que buscan una solución práctica y rápida, no teoría aburrida.'];
const isNotFor = ['Padres que buscan métodos de disciplina militar o castigos físicos.', 'Personas que no están dispuestas a cambiar su propia forma de hablar por 7 días.', 'Quienes buscan soluciones mágicas que no requieran ningún esfuerzo personal.'];
export function WhoIsForSection() {
  return <section className="py-10 md:py-24 bg-maternal-cream" data-id="element-234">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-235">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12" data-id="element-236">
          {/* IS FOR */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-white p-8 md:p-10 rounded-3xl shadow-lg border-t-4 border-green-500" data-id="element-237">
            <h3 className="text-2xl font-bold text-maternal-brown mb-8 flex items-center" data-id="element-238">
              <span className="bg-green-100 text-green-600 p-2 rounded-full mr-3" data-id="element-239">
                <Check className="w-6 h-6" data-id="element-240" />
              </span>
              Esto ES para ti si...
            </h3>
            <ul className="space-y-6" data-id="element-241">
              {isFor.map((text, i) => <li key={i} className="flex items-start" data-id="element-242">
                  <Check className="w-6 h-6 text-green-500 mr-3 flex-shrink-0 mt-0.5" data-id="element-243" />
                  <span className="text-maternal-lightBrown leading-relaxed" data-id="element-244">
                    {text}
                  </span>
                </li>)}
            </ul>
          </motion.div>

          {/* IS NOT FOR */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-maternal-beige p-8 md:p-10 rounded-3xl shadow-md border-t-4 border-red-400" data-id="element-245">
            <h3 className="text-2xl font-bold text-maternal-brown mb-8 flex items-center" data-id="element-246">
              <span className="bg-red-100 text-red-500 p-2 rounded-full mr-3" data-id="element-247">
                <X className="w-6 h-6" data-id="element-248" />
              </span>
              Esto NO es para ti si...
            </h3>
            <ul className="space-y-6" data-id="element-249">
              {isNotFor.map((text, i) => <li key={i} className="flex items-start" data-id="element-250">
                  <X className="w-6 h-6 text-red-400 mr-3 flex-shrink-0 mt-0.5" data-id="element-251" />
                  <span className="text-maternal-lightBrown leading-relaxed" data-id="element-252">
                    {text}
                  </span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}